/**
 * @generated SignedSource<<2d35a64b68ce375d8c885c999b70903b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConnectAdminSiteAdminQuery$variables = Record<PropertyKey, never>;
export type ConnectAdminSiteAdminQuery$data = {
  readonly store: {
    readonly connectConfig: {
      readonly color: string | null;
      readonly email: string | null;
      readonly facebookLink: string | null;
      readonly instagramLink: string | null;
      readonly phoneNumber: string | null;
      readonly site: {
        readonly active: boolean | null;
        readonly publicUrl: string | null;
        readonly qrCode: {
          readonly svg: string | null;
        } | null;
        readonly welcomeMessage: string | null;
      } | null;
    } | null;
    readonly id: string;
    readonly name: string;
  };
};
export type ConnectAdminSiteAdminQuery = {
  response: ConnectAdminSiteAdminQuery$data;
  variables: ConnectAdminSiteAdminQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Store",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConnectConfig",
        "kind": "LinkedField",
        "name": "connectConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookLink",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "instagramLink",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ConnectConfigSite",
            "kind": "LinkedField",
            "name": "site",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "welcomeMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publicUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "active",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "QRCode",
                "kind": "LinkedField",
                "name": "qrCode",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "svg",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConnectAdminSiteAdminQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ConnectAdminSiteAdminQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "30b2bc33f203eb5ebb0cef2d42aff79b",
    "id": null,
    "metadata": {},
    "name": "ConnectAdminSiteAdminQuery",
    "operationKind": "query",
    "text": "query ConnectAdminSiteAdminQuery {\n  store {\n    id\n    name\n    connectConfig {\n      color\n      email\n      phoneNumber\n      facebookLink\n      instagramLink\n      site {\n        welcomeMessage\n        publicUrl\n        active\n        qrCode {\n          svg\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "454cbd0bd95845327ab3cf769efd1f82";

export default node;
